import styled from 'styled-components';
import Login from './login/login.jsx';
import ShoppingCart from './shoppingCart/shoppingCart.jsx'
import logo from '../imgs/logo.png';
import Box from '@mui/material/Box';
import TextField from '@mui/material/TextField';
import SearchIcon from '@mui/icons-material/Search';
import InputAdornment from '@mui/material/InputAdornment';
import { ThemeProvider, createTheme } from '@mui/material/styles';
import { useSelector } from 'react-redux'



const Container=styled.div`
	display:flex;	
	justify-content:space-between;
	align-items:center;
	height:7vh;
	min-height:50px;
	background-color: #F9F9F9;
	


`;

const Logo=styled.img`
	height:5vh;
	margin:9px;
	min-height:30px;
	filter: drop-shadow(0 1px 1px rgba(0, 0, 0, 0.9));
	
`;

const ContainerLogo=styled.div`	
	display:flex;
	justify-content:center;
	align-items:center;
		
 `;

const ContainerLogin=styled.div`	
	display:flex;
	align-items:center;

 `;


 
const ContainerAutoSelect=styled.div`
	display:flex;
	justify-content:space-around;
	align-items:center;
	min-width:55%;
`;

const NombreUser=styled.div`
	margin-left:25px;
		@media (max-width: 1050px){
    	display:none
  	}
`;

const ContainerShoppingCart=styled.div`

	
`;



export default function MenuSuperior(props){
	let { filtroNombre,openLoginShoppingCart } = props;
	let usuario=useSelector(state=>state.login.user.name)
	
	
 	
	let handleChange=(e)=>{
		filtroNombre(e.target.value.toLowerCase())

	};

const lightTheme=createTheme({

 	palette: {
   		 mode: 'light',
    	primary: {
      		main: '#27B0FE',
      		contrastText: '#ffebee',
    	}
  },
    typography: {
      fontFamily: ['Poppins', 'sans-serif'].join(","),
      fontSize: 10,

    }

 });




	return(
		<Container>
			<ThemeProvider theme={lightTheme}>
			<ContainerLogo>
		 		<Logo src={logo}/> <b>Playlan</b>mym™
		 	</ContainerLogo>


    		<ContainerAutoSelect>
    			 <Box sx={{width: 500,maxWidth: '100%',}}    >
      				<TextField fullWidth size="small" label="Busca tu Juego" id="fullWidth"  onChange={handleChange}
      				InputProps={{startAdornment: <InputAdornment position="start"><SearchIcon/></InputAdornment> }}/>
    			</Box>

    			
    				<NombreUser>{usuario}</NombreUser>
    				<ContainerShoppingCart >
    					<ShoppingCart openLoginShoppingCart={openLoginShoppingCart}/>
    				</ContainerShoppingCart>


    			<ContainerLogin>
						<Login />		
					</ContainerLogin>

    		</ContainerAutoSelect>

    		

			
			</ThemeProvider >
		</Container>)
}